module.exports = __webpack_public_path__ + "static/media/AwsDemo-2014.55699fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AwsDemo-2014.png
// module id = 83
// module chunks = 0